import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import { OneFormProjectCard } from "../Project/OneFormProjectCard";
import { ProjectActionCreators, AppActionCreators } from "../../../actions";
import { DistrictDropdownOption, ProjectType } from "../../../utils/enums";
import { RouteUrls } from "../../../configs/routeUrls";
import { PreviewOneFormProjectCard } from "../Project/PreviewOneFormProjectCard";

class BudgetCardPreviewContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let { id } = this.props.match.params;
    if (id) {
      this.props.getProject(id);
    }
    this.props.setBreadcrumbs([
      {
        url: RouteUrls.Budget.list.actual,
        displayName: "Budżet obywatelski",
      },
      {
        url: RouteUrls.Budget.vote.previewFunc(id),
        displayName: "Głosowanie",
      },
    ]);
  }

  render() {
    const {
      isAuth,
      isProjectLoading,
      isOnlyOneOffice,
      loggedUserId,
      opinionExecuting,
      voteExecuting,
      loggedDistrictId,
      externalSystemAddress,
      loggedUserIsCitizen,
      loggedUserOfficeId,
    } = this.props;

    return (
      <OneFormProjectCard
        {...this.props.project}
        consultationTitle="Budżet"
        type={ProjectType.PublicBudget}
        disabled={true}
        isAuth={isAuth}
        isProjectLoading={isProjectLoading}
        isOnlyOneOffice={isOnlyOneOffice}
        loggedUserId={loggedUserId ? loggedUserId : 0}
        loggedUserOfficeId={loggedUserOfficeId}
        loggedDistrictId={
          loggedDistrictId ? loggedDistrictId : DistrictDropdownOption.NotSetted
        }
        loggedUserIsCitizen={loggedUserIsCitizen}
        externalSystemAddress={externalSystemAddress}
        opinionExecuting={opinionExecuting}
        voteExecuting={voteExecuting}
        saveAnswers={(values) => this.props.saveAnswers(values)}
        onCancel={this.props.goBack}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isAuth: state.app.isAuth,
    isProjectLoading: state.project.isProjectLoading,
    isOnlyOneOffice: state.app.offices && state.app.offices.length === 1,
    externalSystemAddress: state.app.officeFooter.eboi || "",
    opinionExecuting: state.project.opinionExecuting,
    voteExecuting: state.project.voteExecuting,
    project: state.project.project,
    loggedUserId: state.app.loggedUser.userId,
    loggedUserOfficeId: state.app.loggedUser.officeId,
    loggedDistrictId:
      state.app.loggedUser.districtId || DistrictDropdownOption.NotSetted,
    loggedUserIsCitizen: state.app.loggedUser.isCitizen || false,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    ...bindActionCreators(
      { ...ProjectActionCreators, ...AppActionCreators },
      dispatch
    ),
    goBack: () => dispatch(goBack()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BudgetCardPreviewContainer);
